import React from "react";
import LandingPage from "./LandingPage";

class aiComposzHomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      mobile: false,
      countryCode: this.getCookie("countryCode")
    };
    // document.cookie = "cartCounter=25;";
  }

  componentDidMount() {
    this.checkDevice();

    if (this.state.countryCode === "") {
      //fetch country code of user
      //var url = 'https://api.ipregistry.co/?key=64qg4jmpagjha51m';
      var url = "https://ipinfo.io/?token=f7e161ea50651f";
      fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
          this.setState({
            countryCode: responseJson.country
          });
          document.cookie = "countryCode=" + responseJson.country + ";";
        })
        .catch((error) => {
          //console.error(error);
          this.setState({
            countryCode: "US"
          });
        });
    }
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkDevice = () => {
    /* Storing user's device details in a variable*/
    let details = navigator.userAgent;

    /* Creating a regular expression  
      containing some mobile devices keywords  
      to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details 
      it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  };

  Fnavbar = () => {
    let Usernavbar = LandingPage(
      this.state.mobile,
      this.props.user_id,
      this.props.imgcredits
    );
    return Usernavbar;
  };

  render() {
    return (
      <React.Fragment>
        <this.Fnavbar />
      </React.Fragment>

      //   <div style={{ paddingLeft: 200 }}>
      //     <h3>Welcome to Enhance Images!</h3>
      //   </div>
    );
  }
}
export default aiComposzHomePage;
